<template>
  <VDropdown
    :auto-hide="true"
    :distance="24"
    :shown="popoverOpen"
    :placement="'auto'"
    :popper-class="'share-popover'"
    :triggers="[]"
    @hide="handlePopoverHide"
  >
    <circular-icon-button
      icon-name="share-item"
      :icon-size="15"
      class="footer-button"
      @click="triggerShare"
    />
    <template #popover>
      <div class="heading">
        {{ title }}
      </div>
      <div class="subheading">
        {{ text }}
      </div>
      <share-box :url="url" />
    </template>
  </VDropdown>
</template>

<script>
import CircularIconButton from '@/components/ui/CircularIconButton';
import ShareBox from '@components/share/shareBox';

export default {
  components: {
    CircularIconButton,
    ShareBox,
  },
  props: {
    category: {
      type: Object,
    },
    flashcard: {
      type: Object,
    },
  },
  data() {
    return {
      popoverOpen: false,
    };
  },
  computed: {
    config() {
      return this.$store.getters['productVars/get']['flashcardShareMessage']?.parsedValue;
    },
    message() {
      return this.config?.message_text;
    },
    title() {
      return this.config?.title || 'Ask a Friend';
    },
    text() {
      return this.config?.text || 'Share this question with a BFF.';
    },
    url() {
      if (this.flashcard && this.config) {
        let url = `${this.config.url}?fid=${this.flashcard.id}`;

        if (this.config.sc) {
          url += `&sc=${this.config.sc}`;
        }

        return url;
      }
    },
  },
  methods: {
    triggerShare() {
      this.popoverOpen = !this.popoverOpen;
    },
    handlePopoverHide() {
      this.popoverOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer-button {
    height: 28px;
    width: 28px;
    display: grid;
    place-items: center;
    background-color: transparent;
    padding: 0;
    border: none;
  }
</style>

<style lang="scss">
.share-popover.v-popper--theme-dropdown {
  max-width: rem-calc(400);

  .v-popper__inner {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
    color: black;
    padding: rem-calc(24);

    .heading {
      font-weight: 600;
      margin-bottom: rem-calc(8);
    }

    .subheading {
      color: #767676;
      font-size: rem-calc(14);
      letter-spacing: -0.5px;
      margin-bottom: rem-calc(20);
    }
  }

  .v-popper__arrow-container {
    display: none;
  }
}
</style>
